import styled from "styled-components";

export const Body = styled.div `
  height: 10%;
  display: grid;
  grid-template-columns: 25% 50% 25%;
  padding: 8px;
`;
